import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-july-offer-popup',
  templateUrl: './july-offer-popup.component.html',
  styleUrls: ['./july-offer-popup.component.scss']
})
export class JulyOfferPopupComponent implements OnInit {
  /** Emitted when the primary CTA ("Add Funds") is clicked. */
  @Output() addFunds = new EventEmitter<void>();

  private readonly offerDeadline = new Date('2026-07-31T23:59:59+05:30');
  daysLeft: number = 0;
  hoursLeft: number = 0;
  minutesLeft: number = 0;
  isExpired: boolean = false;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.updateCountdown();
  }

  updateCountdown(): void {
    const diff = this.offerDeadline.getTime() - Date.now();
    if (diff <= 0) {
      this.isExpired = true;
      this.daysLeft = 0;
      this.hoursLeft = 0;
      this.minutesLeft = 0;
      return;
    }
    this.isExpired   = false;
    this.daysLeft    = Math.floor(diff / (1000 * 60 * 60 * 24));
    this.hoursLeft   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    this.minutesLeft = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  }

  onAddFunds(): void {
    this.addFunds.emit();
  }

  close(): void {
    this.commonService.closePopUp();
  }
}
